export default "__VITE_ASSET__b28739d7__"